import React from 'react';
import { Link, NavLink, Outlet, useParams } from 'react-router-dom';
import { getCompanySlug } from '../../../client-experience/utils/companyAccess';
import { useStorefrontAuth } from '../../auth/context/StorefrontAuthContext';
import { getStorefrontAccountAppointmentsPath } from '../utils/clientPortalPaths';
import '../styles/StorefrontClientPortal.css';

const StorefrontClientPortalLayout = () => {
  const { companyUrl } = useParams();
  const { companyData } = useStorefrontAuth();
  const companySlug = getCompanySlug(companyData) || companyUrl;
  const appointmentsPath = getStorefrontAccountAppointmentsPath(companySlug);

  return (
    <main className="storefront-client-portal">
      <div className="storefront-client-portal__inner container">
        <div className="storefront-client-portal__surface">
          <nav className="storefront-client-portal__nav" aria-label="Account">
            <div className="storefront-client-portal__nav-primary">
              <NavLink
                to={appointmentsPath}
                className={({ isActive }) => `storefront-client-portal__nav-link${isActive ? ' is-active' : ''}`}
              >
                Appointments
              </NavLink>
              <NavLink
                to={`/book/${companySlug}/account/profile`}
                className={({ isActive }) => `storefront-client-portal__nav-link${isActive ? ' is-active' : ''}`}
              >
                Profile
              </NavLink>
              <NavLink
                to={`/book/${companySlug}/account/calendar-sync`}
                className={({ isActive }) => `storefront-client-portal__nav-link${isActive ? ' is-active' : ''}`}
              >
                Calendar
              </NavLink>
            </div>
            <div className="storefront-client-portal__nav-actions">
              <Link
                className="storefront-client-portal-dashboard__primary"
                to={`/book/${companySlug}`}
              >
                Book now
              </Link>
            </div>
          </nav>
          <div className="storefront-client-portal__content">
            <Outlet />
          </div>
        </div>
      </div>
    </main>
  );
};

export default StorefrontClientPortalLayout;
